// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__3OJgS","modal":"styles_modal__10SlQ","copyButton":"styles_copyButton__1nP43"};